import { mapValues } from 'lodash';
/**
 * Version 26 migration changing richTextFields to standard
 */
export default function v26(website) {
  return {
    ...website,
    eventVersion: 26,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'EventIdentityConfirmation') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            adminText: 'EventGuestside_IdentityConfirmation_adminText__resx',
            adminHeaderText: 'EventGuestside_IdentityConfirmation_adminHeaderText__resx'
          }
        };
      }
      return layoutItem;
    })
  };
}
